var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ConfirmationModal',{ref:"modal",attrs:{"title":'Save your comparison list',"text":'If you change the active list, all unsaved changes will be lost. Save changes?'}}),_vm._v(" "),_c('ProfileSaveListModal',{ref:"save_modal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }